/**
 * @generated SignedSource<<05c4980aa0680ed78f7aa83ed3735cb0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductCarouselItem_item$data = {
  readonly hasApprovedVideo?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductImage_item" | "ProductVideo_item">;
  readonly " $fragmentType": "ProductCarouselItem_item";
};
export type ProductCarouselItem_item$key = {
  readonly " $data"?: ProductCarouselItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductCarouselItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchVideo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductCarouselItem_item",
  "selections": [
    {
      "condition": "fetchVideo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasApprovedVideo",
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductVideo_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0ac325e0366b62e5ea35b7d434d3dd97";

export default node;
